module.exports = __webpack_public_path__ + "b89b40eaa5572b3923ad7c0e98ac84d1.png";